<template>
	<div class="prose max-w-none bg-gray-50 antialiased">
		<DefaultHeader :show-menu="showMenu" :show-campaign="showCampaign" />

		<div class="lg:min-h-[670px] xl:min-h-[620px]">
			<slot />
		</div>

		<DefaultFooter v-if="showFooter" />
	</div>
</template>

<script setup>
import DefaultHeader from '@/components/headers/DefaultHeader.vue'
import DefaultFooter from '@/components/footers/DefaultFooter.vue'

/*******
 * Layout settings
 *
 * To disable the footer per page, use definePageMeta({layoutSettings: {showFooter: false}})
 * To disable the menu per page, use definePageMeta({layoutSettings: {showMenu: false}})
 *
 *******/

// we need to call this here to trigger the hydration of the carbar-Au-Auth-Store within the initial setups, otherwise
// we get an "onUnmounted" warning from pinia's persisted state. See DE-5187
isLoggedIn()
checkAuthLoginVersion()

const route = useRoute()
const showFooter = computed(() => route.meta.layoutSettings?.showFooter ?? true)
const showMenu = computed(() => route.meta.layoutSettings?.showMenu ?? true)
const showCampaign = computed(
	() => route.meta.layoutSettings?.showCampaign ?? true
)

const pageMeta = siteMeta(route.path)

if (import.meta.client) {
	useMicrosoftClarity()
	useDealfront()
	useRecaptcha()
}

if (!route.meta.disableGenericCanonical) {
	useHead(() => ({
		// Tile and meta description needs to be declared here, it acts
		// as a fallback for other pages to avoid displaying undefined
		// value in title and meta tag due to reactivity for certain pages ie. vehicle page.
		// Meta values are set in utils siteMeta.js
		title: pageMeta?.title,
		meta: [
			{
				name: 'description',
				content: pageMeta?.description,
			},
			{
				name: 'keywords',
				content: pageMeta?.keywords,
			},
		],
		link: [
			{
				rel: 'canonical',
				href: pageMeta?.url,
			},
		],
		htmlAttrs: {
			lang: pageMeta?.locale,
		},
	}))

	if (import.meta.server) {
		useSeoMeta({
			ogType: pageMeta?.type,
			ogTitle: pageMeta?.title,
			ogUrl: pageMeta?.url,
			ogDescription: pageMeta?.description,
			ogImage: pageMeta?.image,
			ogImageWidth: pageMeta?.imageWidth,
			ogImageHeight: pageMeta?.imageHeight,
			ogLocale: pageMeta?.locale,
			twitterCard: 'summary_large_image',
			twitterSite: '@carbarcomau',
			twitterTitle: pageMeta?.title,
			twitterDescription: pageMeta?.description,
			twitterImage: pageMeta?.image,
		})
	}
}
</script>
